
var popup = document.querySelector('.popup');
  var closeBtn = document.querySelector('.close-btn');
  var customizeAndBuy = document.querySelector('.customize_and_buy');
  var productJson = JSON.parse(document.getElementById('product-json').textContent);
  var productMetaJson = JSON.parse(document.getElementById('product-meta-json').textContent);
  var sampleProductsJson = JSON.parse(document.getElementById('sampleProducts-json').textContent);
  var metaImage = document.querySelector('#chartContainer');
  var metaImageScroll = document.querySelector('#chartContainer-scroll');
  var moneyFormat = document.querySelector('body').getAttribute("data-money-format");
  var widthInput = document.querySelector('#width_in_inches');
  var heightInput = document.querySelector('#height_in_inches');
  var addToCart = document.querySelector('#ms_sp_addto_cart');
  var sizeAlert = document.querySelector('.walltool-size-alert');
  var addToCartMain = document.querySelector('.ms_sp_main');
  var buySampleProducts = document.querySelector('.buy_sample_products');
  var wallpaperSizeRadio = document.querySelectorAll('[name="wallpaper-size"]');
  var selectedDesign =  document.querySelector('#selected-design');
  var loaderWall = document.querySelector('.loader-wall');
  // var propertiesWallpaperSize =  document.querySelector('#properties-wallpaper-size');
  var propertiesDimension = document.querySelector('#properties-dimension');
  var chartContainerMain = document.querySelector('#chartContainer-main');
  var product_image = document.querySelector('#product_image');
  var propertiesPanelWidth = document.querySelector('#properties-panel-width');



  var product_price_js = document.querySelector('.product-price-js');
  var roll_select = document.querySelector('.variant-selector-js');
  var price_main  = document.querySelector('.product-price-container .no-js-hidden');
  var price_roll  = document.querySelector('.product-price-js');
  var productsRollsJson = JSON.parse(document.getElementById('products_rolls-json').textContent);
  var sampleProductsJson = JSON.parse(document.getElementById('sampleProducts-json').textContent);



  closeBtn.addEventListener('click', function() {
     popup.style.display = 'none';
  });
  window.addEventListener('click', function(event) {
     if (event.target == popup) {
        popup.style.display = 'none';
     }
  });

    var brd_bx = document.querySelectorAll('.brd_bx');
    var brdr_cntr = document.querySelector('.brdr_cntr');
    var switch_input = document.querySelector('.switch-input');
    var strips_text = document.querySelector('.strips-text');

    var panelWidth = document.getElementById("panelWidth");
    var panelWidthValue = document.getElementById("panelWidthValue");
    panelWidthValue.innerHTML = panelWidth.value+' inches';
    panelWidth.oninput = function() {
        panelWidthValue.innerHTML = this.value+' inches';
        propertiesPanelWidth.value = this.value+' inches';
        const panelWidthInput = this.value * 1;
        const totalWidthInput = widthInput.value * 1;
        const percentage = (panelWidthInput / totalWidthInput) * 100;
        brd_bx.forEach(function(element) {
            element.style.minWidth = percentage+'%';
        });
    }
       switch_input.addEventListener('change', function() {
         calculatePanels();
        if (switch_input.checked) {
           brdr_cntr.style.display = 'flex';
           //strips_text.innerText = 'Hide Strips';
        } else {
          brdr_cntr.style.display = 'none';
          //strips_text.innerText = 'Show Strips';
        }
      });
    function panelWidthPercentage(){
        const panelWidthInput = panelWidth.value * 1;
        const totalWidthInput = widthInput.value * 1;
        const percentage = (panelWidthInput / totalWidthInput) * 100;
        brd_bx.forEach(function(element) {
        element.style.minWidth = percentage+'%';
        });
    }
//  scrlll on tuch code 
touchScroll('#chartContainer-scroll');

function touchScroll ($bind = '') {
  const slider = document.querySelector($bind);
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
    cancelMomentumTracking();
  });

  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });

  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
    beginMomentumTracking();
  });

  slider.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    var prevScrollLeft = slider.scrollLeft;
    slider.scrollLeft = scrollLeft - walk;
    velX = slider.scrollLeft - prevScrollLeft;
  });
  
  slider.addEventListener('wheel', (e) => {
    cancelMomentumTracking();
  });  
  var velX = 0;
  var momentumID;

  function beginMomentumTracking(){
    cancelMomentumTracking();
    momentumID = requestAnimationFrame(momentumLoop);
  }
  function cancelMomentumTracking(){
    cancelAnimationFrame(momentumID);
  }
  function momentumLoop(){
    slider.scrollLeft += velX;
    velX *= 0.95; 
    if (Math.abs(velX) > 0.5){
      momentumID = requestAnimationFrame(momentumLoop);
    }
  }
}
//  scrlll on tuch code end
    


//  scrlll on tuch code 
touchScrollNew('.brdr_cntr');

function touchScrollNew($bind = '') {
  const slider = document.querySelector('#chartContainer-scroll');
  const element = document.querySelector($bind);
  let isDown = false;
  let startX;
  let scrollLeft;

  element.addEventListener('mousedown', handleStart);
  element.addEventListener('touchstart', handleStart);

  element.addEventListener('mouseleave', handleEnd);
  element.addEventListener('mouseup', handleEnd);
  element.addEventListener('touchend', handleEnd);

  element.addEventListener('mousemove', handleMove);
  element.addEventListener('touchmove', handleMove);

  element.addEventListener('wheel', cancelMomentumTracking);

  let velX = 0;
  let momentumID;

  function handleStart(e) {
    e.preventDefault();
    isDown = true;
    slider.classList.add('active');

    if (e.type === 'touchstart') {
      startX = e.touches[0].pageX - slider.offsetLeft;
    } else {
      startX = e.pageX - slider.offsetLeft;
    }

    scrollLeft = slider.scrollLeft;
    cancelMomentumTracking();
  }

  function handleEnd() {
    isDown = false;
    slider.classList.remove('active');
    beginMomentumTracking();
  }

  function handleMove(e) {
    if (!isDown) return;
    e.preventDefault();

    let x;
    if (e.type === 'touchmove') {
      x = e.touches[0].pageX - slider.offsetLeft;
    } else {
      x = e.pageX - slider.offsetLeft;
    }

    const walk = (x - startX) * 3; //scroll-fast
    const prevScrollLeft = slider.scrollLeft;
    slider.scrollLeft = scrollLeft - walk;
    velX = slider.scrollLeft - prevScrollLeft;
  }

  function beginMomentumTracking() {
    cancelMomentumTracking();
    momentumID = requestAnimationFrame(momentumLoop);
  }

  function cancelMomentumTracking() {
    cancelAnimationFrame(momentumID);
  }

  function momentumLoop() {
    slider.scrollLeft += velX;
    velX *= 0.95;
    if (Math.abs(velX) > 0.5) {
      momentumID = requestAnimationFrame(momentumLoop);
    }
  }
}
//  scrlll on tuch code end
    

    
  function openPopup() {
     popup.style.display = 'block';
  }
  
    function convertToSquareMeters(widthInInches, heightInInches) {
     var squareFoot = (heightInInches * widthInInches) / 144;
     var roundedNumber = Math.ceil(squareFoot);
     return roundedNumber;
  }
  
    function changeTheDimensions() {
    calculatePanels();
      
    var id  = parseInt(document.querySelector('[name="id"]').value);
    var widthMin = parseFloat(widthInput.getAttribute("min"));
    var widthMax = parseFloat(widthInput.getAttribute("max"));
    var heightMin = parseFloat(heightInput.getAttribute("min"));
    var heightMax = parseFloat(heightInput.getAttribute("max"));
    var widthInInches = parseFloat(widthInput.value);
    var heightInInches = parseFloat(heightInput.value);
    var maxSquareFoot = parseFloat(widthInput.getAttribute("data"));
    var squareFoot = convertToSquareMeters(widthInInches, heightInInches);
    var error = false;
    
    if( widthInput.value == '' || widthInInches < widthMin ){
    widthInput.closest(".span_1_of_2").classList.add("error");
    addToCart.disabled = true;
    error = true;
    }else{
    widthInput.closest(".span_1_of_2").classList.remove("error");
    }
    if( heightInput.value == '' || heightInInches < heightMin || heightInInches > heightMax){
    heightInput.closest(".span_1_of_2").classList.add("error"); 
    error = true;
    addToCart.disabled = true;
    }else{
    heightInput.closest(".span_1_of_2").classList.remove("error");
    }
    if(squareFoot > maxSquareFoot && error === false){
    sizeAlert.style.display = 'block';
    addToCartMain.style.display = 'none';
    error = true;
    }else if(error === false){
    addToCart.disabled = false;
    sizeAlert.style.display = 'none';
    addToCartMain.style.display = 'block';
    backgroundRepete(widthInInches, heightInInches);
    propertiesDimension.value = 'W: '+widthInInches+' in x H: '+heightInInches+' in ('+squareFoot+' sq ft)';
    Object.keys(productJson).forEach(function(key) {
    if(productJson[key].id === id){
    var productProperties = productJson[key].price;
    var newPrice = productProperties * squareFoot;
    document.querySelector('.m2').innerHTML = squareFoot;
    document.querySelector('.product_properties span').innerHTML = Shopify.formatMoney(productProperties, moneyFormat);
    document.querySelector('[name="quantity"]').value = squareFoot;
    document.getElementById('properties-set').value = squareFoot;
    document.querySelector('.product_pricing').innerHTML = Shopify.formatMoney(newPrice, moneyFormat);
    }
    });
    }
      panelWidthPercentage();
    }


// ##############################################################################################################
function backgroundRepete(widthInInches, heightInInches){
var imgSrc = '';
var id  = parseInt(document.querySelector('[name="id"]').value);
Object.keys(productMetaJson).forEach(function(key) {
if(productMetaJson[key].variant_id == id){
imgSrc = productMetaJson[key].img;
}
});
  var wallpaperImg = new Image();
wallpaperImg.src = imgSrc
wallpaperImg.onload = function() {
var wallpaperImgWidth = wallpaperImg.naturalWidth;
var wallpaperImgHeight = wallpaperImg.naturalHeight;
var wallpaperImgHeightRato = wallpaperImgWidth/wallpaperImgHeight;
var rato = widthInInches/heightInInches;
var wallpaperSize = heightInInches;
var wallpaperWidth = ((heightInInches/widthInInches)*100)*wallpaperImgHeightRato;
var wallpaperWidth1 = ((widthInInches/(heightInInches*wallpaperImgHeightRato))*100);
if(wallpaperWidth1 < 100 ){
var wallpaperWidthPx = (widthInInches*wallpaperImgHeight)/heightInInches;
var product_image_width = product_image.offsetWidth;
if(wallpaperWidthPx > (product_image_width - 20)){
chartContainerMain.style.width = '100%';
}else{
chartContainerMain.style.width = wallpaperWidthPx+'px';
}

}else{
chartContainerMain.style.width = '100%';
}
var count = Math.ceil(100/wallpaperWidth);

var vImage = imgSrc;
  metaImage.innerHTML = '';
for(var i=0;i<count;i++){
var img = document.createElement("img");
img.src = vImage;
img.style.width = wallpaperWidth+'%';
 metaImage.appendChild(img);
}
metaImageScroll.scrollLeft = 0;
}
}
// ##############################################################################################################
    var timer = null;
    widthInput.addEventListener('keyup', function() {
    addToCart.disabled = true;
    var inputVal = this.value;
    var inputRGEX = /^[0-9.]*$/;
    var inputResult = inputRGEX.test(inputVal);
    if (!(inputResult)) {
    this.value = this.value.replace(/[^0-9.]/g, '');
    }
    if (isNaN(inputVal)) {
    widthInput.closest(".span_1_of_2").classList.add("error");
    addToCart.disabled = true;
    }else{
    clearTimeout(timer);
    timer = setTimeout(function() {
    changeTheDimensions();
    }, 1800); 
    }
    });


    heightInput.addEventListener('keyup', function() {
    addToCart.disabled = true;
    var inputVal = this.value;
    var inputRGEX = /^[0-9.]*$/;
    var inputResult = inputRGEX.test(inputVal);
    if (!(inputResult)) {
    this.value = this.value.replace(/[^0-9.]/g, '');
    }
    if (isNaN(inputVal)) {
    heightInput.closest(".span_1_of_2").classList.add("error");
    addToCart.disabled = true;
    }else{
    clearTimeout(timer);
    timer = setTimeout(function() {
    changeTheDimensions();
    }, 1800); 
    }
    });

    window.addEventListener('resize', function() {
    clearTimeout(timer);
    timer = setTimeout(function() {
    changeTheDimensions();
    }, 1800); 
    });

//   wallpaperSizeRadio.forEach(function(element) {
//   element.addEventListener('change', function() {
//     // Handle the change event here
//      changeTheDimensions();
//   });
// });

 
    $(customizeAndBuy).on('click', function() {
        let id = parseInt($('[name="id"]').val());

        $('.custom-variations fieldset').each(function() {
            let $fieldset = $(this);
            let customOption = $fieldset.attr("data");
            let matchingProduct = productJson.find(p => p.id === id);
            
            if (matchingProduct) {
                let value = matchingProduct[customOption];

                if ($fieldset.find('select').length) {
                    $fieldset.find('select').val(value).trigger('change');
                } else if ($fieldset.find('input').length) {
                    $fieldset.find('input').each(function() {
                        if ($(this).val() === value) {
                            $(this).prop("checked", true).trigger('change');
                            $fieldset.find('.form__label__value').text(value);
                        }
                    });
                }
            }
        });
        openPopup();
        changeTheDimensions();
    });

  // customizeAndBuy.addEventListener('click', function() {
  // var id  = parseInt(document.querySelector('[name="id"]').value);
  // document.querySelectorAll(".MS_option-name").forEach((el, idx) => {
  // var option = el.getAttribute("data");  
  // Object.keys(productJson).forEach(function(key) {
  //  if(productJson[key].id == id){
  // console.log(productJson[key][option]);
  // el.querySelector('.option-value').innerHTML = productJson[key][option];  
  //  }
  // });

  // });
  // openPopup();
  // changeTheDimensions();
  // });


    function addToCartItem1(properties,sampleProductsId,qty) {
       var data = {
        id: sampleProductsId,
        quantity:qty,
        "properties": properties
      }
      console.log(data);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(res => {
        if(res.status == 422){
          //location.reload();
        } else {
        window.location.href = '/cart'; 
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
      }

    function getSKUById(id) {
        const product = productJson.find(item => item.id === id);
        return product ? product.sku : "Product not found";
    }

    buySampleProducts.addEventListener('click', function(event) {
    event.preventDefault();
    var properties = {};
    var productTitle = document.querySelector('.product-title').innerText;
    var id  = parseInt(document.querySelector('[name="id"]').value);
    document.querySelectorAll(".MS_option-name").forEach((el, idx) => {
    var option = el.getAttribute("data");
    var optionName = el.querySelector('.option-name').innerText;
    properties['Title'] = productTitle;
    if(optionName != 'Material'){
      Object.keys(productJson).forEach(function(key) {
       if(productJson[key].id == id){
          properties[optionName] = productJson[key][option];
      }
      });
    }
    const sku = getSKUById(id);
    properties['Product ID'] = sku;
    });

    Object.keys(productMetaJson).forEach(function(key) {
     if(productMetaJson[key].variant_id == id){
     var vImage = productMetaJson[key].img;
     console.log(productMetaJson[key].img);
     properties['Selected Design'] = productMetaJson[key].img;
     }
    });

   var Material = document.querySelector('[name="options[Material]"]');
    if(Material){
    var sampleMaterial  = Material.value;
    }else{
    var sampleMaterial  = document.querySelector('[name="Material"]:checked').value;
    }
      
    var rollSize  = document.querySelector('.variant-selector-js').value;
    var qty  = parseInt(document.querySelector('#Quantity-products_rolls').value);

    var title = sampleMaterial+' / '+rollSize;
    var sampleProductsId;
    Object.keys(productsRollsJson).forEach(function(key) {
     if(productsRollsJson[key]['title'] == title){
    //alert(productsRollsJson[key].id);
     sampleProductsId = productsRollsJson[key].id;
    }
    });
      addToCartItem1(properties,sampleProductsId,qty);
    });

const apikey = 'AqgxrCHmDSGVoHSDmMIc9z';
const client = filestack.init(apikey);
const token = {}; 
   
addToCart.addEventListener('click', function() {
  loaderWall.style.display = 'flex';
      brdr_cntr.style.display = 'none';
    switch_input.checked = false;
// Select the HTML element to capture
var node = document.querySelector('#chartContainer-scroll');
// Use the domtoimage library to convert the element to a PNG image data URL

    var element = document.getElementById("chartContainer-scroll");
 html2canvas(element, {
    useCORS: true // Disable cross-origin requests
  }).then(function(canvas) {
    var imgData = canvas.toDataURL("image/png");
    var img = new Image();
    img.src = imgData;
    var file = img.src;
    console.log(file);
   client.upload(file, {}, token)
      .then(res => {
      console.log('success: ', res.url);
      selectedDesign.value = res.url;
      document.querySelector('.single_add_to_cart_button').click();
      loaderWall.style.display = 'block';
      popup.style.display = 'none';
      loaderWall.style.display = 'none';
      })
      .catch(err => {
        console.log(err)
        loaderWall.style.display = 'none';
      });
  })
  .catch(error => {
    // Handle any errors that may occur
    console.error(error);
    loaderWall.style.display = 'none';
  });
});
  var quickView = localStorage.getItem("quickView");
  if(quickView == 'true'){
  openPopup();
  changeTheDimensions();
  localStorage.setItem("quickView", "false");
  }




  buySampleProducts.addEventListener('click', function(event) {
    event.preventDefault();

    var properties = {};
    console.log(productJson);
    var productTitle = document.querySelector('.product-title').innerText;
    var id  = parseInt(document.querySelector('[name="id"]').value);
    document.querySelectorAll(".MS_option-name").forEach((el, idx) => {
    var option = el.getAttribute("data");
    var optionName = el.querySelector('.option-name').innerText;
    properties['Title'] = productTitle;
    if(optionName != 'Material'){
      Object.keys(productJson).forEach(function(key) {
       if(productJson[key].id == id){
          //alert(productJson[key].featured_image.src);
          properties[optionName] = productJson[key][option];
      }
      });
    }
    });

    Object.keys(productMetaJson).forEach(function(key) {
     if(productMetaJson[key].variant_id == id){
     var vImage = productMetaJson[key].img;
     console.log(productMetaJson[key].img);
     properties['Selected Design'] = productMetaJson[key].img;
     }
    });

   var Material = document.querySelector('[name="options[Material]"]');
    if(Material){
    var sampleMaterial  = Material.value;
    }else{
    var sampleMaterial  = document.querySelector('[name="Material"]:checked').value;
    }
    var rollSize  = document.querySelector('.variant-selector-js').value;
    var qty  = parseInt(document.querySelector('#Quantity-products_rolls').value);

    var title = sampleMaterial+' / '+rollSize;
    var sampleProductsId;
    Object.keys(productsRollsJson).forEach(function(key) {
     if(productsRollsJson[key]['title'] == title){
     sampleProductsId = productsRollsJson[key].id;
    }
    });
      addToCartItem1(properties,sampleProductsId,qty);
    });
  
  function handleChange() {
   var Material = document.querySelector('[name="options[Material]"]');
    if(Material){
    var sampleMaterial  = Material.value;
    }else{
    var sampleMaterial  = document.querySelector('[name="Material"]:checked').value;
    }
        var buySampleProducts = document.querySelector('.buy_sample_products');
    var rollSize  = document.querySelector('.variant-selector-js').value;
    if(rollSize != ''){
    var title = sampleMaterial+' / '+rollSize;
    price_main.style.display = 'none';
    price_roll.style.display = 'flex';
    Object.keys(productsRollsJson).forEach(function(key) {
    if(productsRollsJson[key]['title'] == title){
    var roll_available = productsRollsJson[key].available;
    var price = productsRollsJson[key].price;
    if(roll_available === true){
      product_price_js.innerHTML =  Shopify.formatMoney(price, moneyFormat)+ ' / roll';
      buySampleProducts.disabled = false;
     buySampleProducts.innerText = "Add To Cart";
    }else{
      product_price_js.innerHTML =  Shopify.formatMoney(price, moneyFormat)+ ` / roll <span class="badges"><span class="badge out-of-stock">Sold Out</span></span>`;
      buySampleProducts.disabled = true;
     buySampleProducts.innerText = "Sold Out";
    }
    }
    });

    }else{
    buySampleProducts.disabled = true;
    price_main.style.display = 'block';
    price_roll.style.display = 'none';
    }
    }

  function handleChangeMaterial() {
   var Material = document.querySelector('[name="options[Material]"]');
    if(Material){
    var sampleMaterial  = Material.value;
    }else{
    var sampleMaterial  = document.querySelector('[name="Material"]:checked').value;
    }
      var buySampleProducts = document.querySelector('.buy_sample_products');
    var rollSize  = document.querySelector('.variant-selector-js').value;
    if(rollSize != ''){
    var title = sampleMaterial+' / '+rollSize;
    Object.keys(productsRollsJson).forEach(function(key) {
    if(productsRollsJson[key]['title'] == title){
    var roll_available = productsRollsJson[key].available;
    var price = productsRollsJson[key].price;
    if(roll_available === true){
      product_price_js.innerHTML =  Shopify.formatMoney(price, moneyFormat)+ ' / roll';
      buySampleProducts.disabled = false;
     buySampleProducts.innerText = "Add To Cart";
    }else{
      product_price_js.innerHTML =  Shopify.formatMoney(price, moneyFormat)+ ` / roll <span class="badges"><span class="badge out-of-stock">Sold Out</span></span>`;
      buySampleProducts.disabled = true;
     buySampleProducts.innerText = "Sold Out";
    }
    }
    });
    }
    }

   var materialElements = document.querySelectorAll('[name="options[Material]"]');
    if(materialElements.length === 0){
        var materialElements = document.querySelectorAll('[name="Material"]');
    }
 
    materialElements.forEach(element => {
    element.addEventListener('change', handleChangeMaterial);
    });

  roll_select.addEventListener('change', function() {
      handleChange();
    });
  roll_select.dispatchEvent(new Event('change'));
  
  function orderTypeChange(){
    var main_roll = document.querySelector('.products_rolls-main');
    var button_container = document.querySelector('.button-container');
    if(this.value == 'custom'){
    main_roll.style.display = 'none';
    button_container.style.display = 'block';
    price_main.style.display = 'block';
    price_roll.style.display = 'none';
    }else{
    main_roll.style.display = 'block';
    button_container.style.display = 'none';
    var rollSize  = document.querySelector('.variant-selector-js').value;
    if(rollSize != ''){
    price_main.style.display = 'none';
    price_roll.style.display = 'flex';
    }else{
    price_main.style.display = 'block';
    price_roll.style.display = 'none';
    }
   
    }
    }

  const orderTypeElements = document.querySelectorAll('[name="orderType"]');
    orderTypeElements.forEach(element => {
    element.addEventListener('change', orderTypeChange);
    });

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var rollSize  = document.querySelector('.variant-selector-js').value;
    if(rollSize != ''){
    var buySampleProducts = document.querySelector('.buy_sample_products');
    if (buySampleProducts) {
      console.log(rollSize);
        buySampleProducts.disabled = false;
    }
    }
}, 2000);

});

  //  new code march 2025

$(".unit-selector").on("change", function () {
    const selectedUnit = $(this).val();

    // Set all dropdowns to the selected value
    $(".unit-selector").val(selectedUnit);
    
    // Update the text elements with the selected unit
    $(".unit-change-text").text(selectedUnit);

    const heightInInches = parseFloat($("#height_in_inches").val()) || 0;
    const widthInInches = parseFloat($("#width_in_inches").val()) || 0;

    let heightConverted, widthConverted;

    switch (selectedUnit) {
        case "cm":
            heightConverted = heightInInches * 2.54;
            widthConverted = widthInInches * 2.54;
            break;
        case "ft":
            heightConverted = heightInInches / 12;
            widthConverted = widthInInches / 12;
            break;
        case "m":
            heightConverted = heightInInches * 0.0254;
            widthConverted = widthInInches * 0.0254;
            break;
        default:
            heightConverted = heightInInches;
            widthConverted = widthInInches;
    }

    $("#height_in_inches_input").val(heightConverted.toFixed(2));
    $("#width_in_inches_input").val(widthConverted.toFixed(2));
});



let timer1 = null;

$("#width_in_inches_input").on("keyup", function () {
    const inputElement = $(this); // Store reference to the input element

    clearTimeout(timer1);
    timer1 = setTimeout(function () {
        const unit = $(".unit-selector").val();
        let newValue = parseFloat(inputElement.val()) || 0;
        let convertedValue;

        switch (unit) {
            case "cm":
                convertedValue = newValue / 2.54;
                break;
            case "ft":
                convertedValue = newValue * 12;
                break;
            case "m":
                convertedValue = newValue / 0.0254;
                break;
            default:
                convertedValue = newValue;
        }

        const inchValue = convertedValue.toFixed(2);

        if (inputElement.attr("id") === "width_in_inches_input") {
            $("#width_in_inches").val(inchValue).trigger("keyup"); // Trigger keyup event
        } else if (inputElement.attr("id") === "height_in_inches_input") {
            $("#height_in_inches").val(inchValue).trigger("keyup"); // Trigger keyup event
        }

        changeTheDimensions();
    }, 1800);
});
let timer2 = null;
$("#height_in_inches_input").on("keyup", function () {
    const inputElement = $(this); // Store reference to the input element

    clearTimeout(timer2);
    timer2 = setTimeout(function () {
        const unit = $(".unit-selector").val();
        let newValue = parseFloat(inputElement.val()) || 0;
        let convertedValue;

        switch (unit) {
            case "cm":
                convertedValue = newValue / 2.54;
                break;
            case "ft":
                convertedValue = newValue * 12;
                break;
            case "m":
                convertedValue = newValue / 0.0254;
                break;
            default:
                convertedValue = newValue;
        }

        const inchValue = convertedValue.toFixed(2);

        if (inputElement.attr("id") === "width_in_inches_input") {
            $("#width_in_inches").val(inchValue).trigger("keyup"); // Trigger keyup event
        } else if (inputElement.attr("id") === "height_in_inches_input") {
            $("#height_in_inches").val(inchValue).trigger("keyup"); // Trigger keyup event
        }

        changeTheDimensions();
    }, 1800);
});



function calculatePanels() {
    var totalWidth = $('#width_in_inches').val();
    const minPanelWidth = parseFloat($('#panelWidth').attr('min')) || 19;
    const maxPanelWidth = parseFloat($('#panelWidth').attr('max')) || 39.4;
    let numPanels = Math.ceil(totalWidth / maxPanelWidth);
    let panelWidthData = totalWidth / numPanels;
    if (panelWidthData < minPanelWidth) {
        numPanels = Math.ceil(totalWidth / minPanelWidth);
        panelWidthData = minPanelWidth;
    }
    panelWidthData = Math.round(panelWidthData * 100) / 100;
    $(panelWidth).val(panelWidthData);
    $(propertiesPanelWidth).val(panelWidthData+' inches');
    $(panelWidthValue).text(panelWidthData + ' inches');
}
